import { Image, UIText2 } from '@cian/ui-kit';
import { numberToPrettyString } from '@cian/utils';
import * as React from 'react';
import { ISuburbanProjectSuggest } from 'shared/types/suburbanBuildersProjects';

import * as styles from './ProjectItem.css';
import { Link } from '../../../Link';

interface IProjectItemProps extends ISuburbanProjectSuggest {
  onClick(): void;
}

export const ProjectItem: React.FC<IProjectItemProps> = ({
  projectId,
  projectName,
  startPrice,
  area,
  materials,
  image,
  onClick,
}) => {
  const projectInfo = React.useMemo(
    () => [area && `${area} м²`, !!materials.length && materials.join(', ')].filter(Boolean).join(' ･ '),
    [area, materials],
  );

  const href = React.useMemo(() => `/country-projects/${projectId}/`, [projectId]);

  return (
    <Link url={href} className={styles['link']} onClick={onClick} target="_blank" dataMark="ProjectItem">
      <Image src={image} objectFit="cover" width="100%" height={120} />
      <div className={styles['info']}>
        <UIText2 fontWeight="bold">{projectName}</UIText2>
        <UIText2>от {numberToPrettyString(startPrice)} ₽</UIText2>
        <UIText2>{projectInfo}</UIText2>
      </div>
    </Link>
  );
};
